import { render, staticRenderFns } from "./SubLocations.vue?vue&type=template&id=ba27aa8a&scoped=true&"
import script from "./SubLocations.vue?vue&type=script&lang=js&"
export * from "./SubLocations.vue?vue&type=script&lang=js&"
import style0 from "./SubLocations.vue?vue&type=style&index=0&id=ba27aa8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba27aa8a",
  null
  
)

export default component.exports